var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('hbt-navbar',{attrs:{"endtime":_vm.endtime}}),_c('router-view',{staticClass:"view",attrs:{"endtime":_vm.endtime}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }